import React, {useState} from 'react';
import 'whatwg-fetch';
import {Modal} from "react-bootstrap";
import {authHeaders} from "../Utils/authUtils";
import {APIPATH} from "../settings";
import SelectSearch from "react-select-search";
import "./Notas.css"


function AltaNota(props) {
    const newNota = {
        paciente: "",
        usuario: "",
        titulo: "",
        texto: "",
    }

    const [nota, setNota] = useState(newNota)

    function handle_input(e) {
        const {value, name} = e.target
        setNota(prev => ({...prev, [name]: value}))
    }

    function handle_paciente(value, object) {
        setNota(prev => ({...prev, paciente: value}))
    }

    function crear_nota(e) {
        let {user} = sessionStorage.getItem('userToken') !== null && JSON.parse(sessionStorage.getItem('userToken'));
        const data = {...nota, usuario: user.id}
        authHeaders().then(authHeader => {
            const endpoint = APIPATH + 'api/notas/'
            const lookupOptions = {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    ...authHeader
                },
                credentials: 'include',
                body: JSON.stringify(data)
            }
            fetch(endpoint, lookupOptions).then(
                response => response.json()
            ).then(
                response => {
                    setNota(newNota)
                    props.alta(response)
                    props.handleClose()

                }
            ).catch(
                error => {
                    console.log("error", error)
                }
            )
        })
    }


    return (
        <div>
            <Modal show={props.show} onHide={props.handleClose} animation={false} size="xl">
                <Modal.Header closeButton>
                    <h5 className="modal-title">Alta Nota</h5>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <label className=" ml-3 mr-2 ">Paciente</label>
                        {props.pacientes.length > 0 &&
                        <SelectSearch
                            className="select-search ml-3 select-1"
                            value={nota.paciente}
                            options={[{name: "...", value: ""}, ...props.pacientes.map((paciente, index) =>
                                ({name: paciente.alias, value: paciente.id})
                            )]}
                            search
                            printOptions="on-focus"
                            placeholder={" ... "}
                            onChange={handle_paciente}
                        />
                        }
                    </div>
                    <div className="form-group ">
                        <label htmlFor="titulo">Titulo</label>
                        <input type='text' id="titulo"
                               className={` w-100 form-control `}
                               name="titulo" value={nota.titulo} onChange={handle_input}/>
                    </div>
                    <div className="form-group ">
                        <label htmlFor="texto">Texto</label>
                        <textarea id="texto" rows="10"
                                  className={` w-100 form-control `}
                                  name="texto" value={nota.texto} onChange={handle_input}/>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={props.handleClose}>Cancelar</button>

                    <button type="button" className="btn btn-primary" onClick={crear_nota}
                            disabled={nota.texto === "" || nota.paciente === ""}>Crear
                    </button>
                </Modal.Footer>
            </Modal>

        </div>
    )
}

export default AltaNota;